import styled, { css } from 'styled-components';
import SectionContainer from '../SectionContainer';
import { LogoContainer } from '../Logotype/styles';

export const HeaderContainer = styled(SectionContainer)`
  align-items: center;

  @media(min-width: 1024px) {
    max-width: 1440px;
  }
`;

export const ToggleButton = styled.button`
  position: relative;
  z-index: 3;
  margin: 0;
  padding: 0;

  font-size: 0;

  background-color: transparent;
  border: none;
  outline: none;

  cursor: pointer;

  svg {
    fill: ${({ theme }) => theme.white};
  }

  @media(min-width: 1024px) {
    display: none;
  }
`;

export const HeaderTag = styled.header`
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;

  width: 100%;
  padding: 35px 0;

  color: ${({ theme }) => theme.white};

  @media(min-width: 768px) {
    padding: 34px 0;
  }

  @media(min-width: 1024px) {
    padding: 60px 0;
  }

  ${({ isInnerPage, theme }) => isInnerPage && css`
    position: ${({ fixed }) => fixed ? 'sticky' : 'relative' };

    padding: 15px 0;

    color: ${theme.black};
    background-color: ${theme.white};

    border-bottom: 1px solid ${theme.lightGray};

    a {
      transition: color 0.3s;

      &:hover {
        color: ${theme.blue};
      }
    }

    @media(min-width: 1024px) {
      padding: 30px 0;
    }

    ${LogoContainer} svg {
      fill: ${theme.blue};
    }

    ${ToggleButton} svg {
      fill: ${theme.blue};
    }
  `}

  ${({ isOpen, theme }) => isOpen && css`
    color: ${theme.white};

    a:hover {
      color: currentColor;
    }

    ${LogoContainer} svg {
      fill: ${theme.white};
    }

    ${ToggleButton} svg {
      fill: ${theme.white};
    }
  `}
`;
